/** @jsx jsx */
import {jsx} from "theme-ui"
import Layout from "../layout"
import Paragraph from "../paragraph"
import SectionHeading from "../SectionHeading"
import Button from "../Button/button"
import IconButton from "../Button/IconButton"
import DesktopScreenshot from "./Orderonline/DesktopScreenshot"
import MobileScreenshot from "./Orderonline/MobileScreenshot"
import Ornament1 from "../Ornaments/Ornament1"
// Icons
import Smartphone from "../../icons/mobile-phone.svg"

export default function OrderOnline(props){
    return(
        <Layout>
            <div sx={{
                display: ['block', 'block','flex'],
                alignItems: 'center',
                position: 'relative',
                my: [10, 17, 17]
            }} id={props.id}>
                <div sx={{
                    position: 'relative',
                    mr: [0,0,8],
                    mb: [12, null, null]
                }}>
                    {props.hasOrnaments ? (
                        <div sx={{
                            width: '40%',
                            position: 'absolute',
                            bottom: '-5rem',
                            left: '-5rem',
                            zIndex: 3
                        }}><Ornament1 /></div>
                    ) : ( null ) }
                    <div sx={{width: ['100%','90%','34rem'], position: 'relative', margin: '0 auto'}}>
                        <DesktopScreenshot />
                        <MobileScreenshot />
                    </div>
                </div>
                <div sx={{textAlign: ['center', null, null]}}>
                    <SectionHeading caption="For pickup, curbside or delivery" smallMargin>Order Online</SectionHeading>
                    <Paragraph>Fast and easy ordering from your computer or phone</Paragraph>
                    <a href="https://ehungry.com/"><Button><IconButton><Smartphone /></IconButton> Try it now</Button></a>
                </div>
            </div>
        </Layout>
    )
}